const mutations = {
    setOrg: (state, payload) => {
        state.org = payload;
        state.phons = [];
        state.emails = [];
        if (payload && payload.relatedContacts && payload.relatedContacts.length > 0){
            for (let index = 0; index < payload.relatedContacts.length; index++) {
                const element = payload.relatedContacts[index];
                 if (element.type === 'PHONE'){
                    state.phons.push(element)
                }
                if (element.type === 'EMAIL'){
                    state.emails.push(element)
                }
            }
        }
    },
    setLastUpdatedDataOrg: (state,payload) => {
        state.lastUpdatedDataOrg = payload;
    },
    setImageOrg:(state,payload) =>{
       if(!payload){
            payload = {
               bannerMain: 'https://www.df.gov.br/wp-conteudo/themes/templategdf/img/destaque_conheca_brasilia.jpg',
               bannerDoubt: require('@/assets/images/footerBanner.png'),
           };
       }
       state.images = payload
    },
    setSolicitation: (state,payload) => {
        state.solicitation = payload;
    }

};

export default mutations;
